import { render, staticRenderFns } from "./orderdetails.vue?vue&type=template&id=85ec0006&scoped=true"
import script from "./orderdetails.vue?vue&type=script&lang=ts"
export * from "./orderdetails.vue?vue&type=script&lang=ts"
import style0 from "./orderdetails.vue?vue&type=style&index=0&id=85ec0006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ec0006",
  null
  
)

export default component.exports